export default class AgentModel {
  constructor (data = {}) {
    this.id = data.id || null
    this.name = data.name || ''
    this.description = data.description || ''
    this.llmProvider = data.llmProvider || ''
    const incomingConfig = data.configuration || {}
    // UX defaults for non-technical users (only applied when missing)
    this.configuration = {
      model: incomingConfig.model || '',
      temperature: (incomingConfig.temperature !== undefined && incomingConfig.temperature !== null)
        ? incomingConfig.temperature
        : 0.6,
      maxTokens: (incomingConfig.maxTokens !== undefined && incomingConfig.maxTokens !== null)
        ? incomingConfig.maxTokens
        : 2000,
      topP: (incomingConfig.topP !== undefined && incomingConfig.topP !== null)
        ? incomingConfig.topP
        : 0.75,
      systemPrompt: incomingConfig.systemPrompt || ''
    }
    this.isActive = data.isActive !== undefined ? data.isActive : true
    this.sessionCount = data.sessionCount || 0
    this.projectCount = data.projectCount || 0
    this.knowledgeBaseCount = data.knowledgeBaseCount || 0
    this.lastUsedAt = data.lastUsedAt || null
    this.createdAt = data.createdAt || null
    this.updatedAt = data.updatedAt || null
  }

  loadModel (agentData) {
    this.id = agentData.id
    this.name = agentData.name
    this.description = agentData.description
    this.llmProvider = agentData.llmProvider
    const incomingConfig = agentData.configuration || {}
    this.configuration = {
      model: incomingConfig.model || '',
      temperature: (incomingConfig.temperature !== undefined && incomingConfig.temperature !== null)
        ? incomingConfig.temperature
        : 0.6,
      maxTokens: (incomingConfig.maxTokens !== undefined && incomingConfig.maxTokens !== null)
        ? incomingConfig.maxTokens
        : 2000,
      topP: (incomingConfig.topP !== undefined && incomingConfig.topP !== null)
        ? incomingConfig.topP
        : 0.75,
      systemPrompt: incomingConfig.systemPrompt || ''
    }
    this.isActive = agentData.isActive
    this.sessionCount = agentData.sessionCount || 0
    this.projectCount = agentData.projectCount || 0
    this.knowledgeBaseCount = agentData.knowledgeBaseCount || 0
    this.lastUsedAt = agentData.lastUsedAt
    this.createdAt = agentData.createdAt
    this.updatedAt = agentData.updatedAt
  }

  toCreateDto () {
    return {
      name: this.name,
      description: this.description,
      llmProvider: this.llmProvider,
      configuration: this.configuration,
      isActive: this.isActive
    }
  }

  getProviderIcon () {
    const icons = {
      OpenAI: 'fas fa-brain',
      Claude: 'fas fa-cloud',
      Gemini: 'fas fa-star',
      Grok: 'fas fa-bolt'
    }
    return icons[this.llmProvider] || 'fas fa-robot'
  }

  getStatusBadgeClass () {
    return this.isActive ? 'badge-success' : 'badge-secondary'
  }

  getStatusText () {
    return this.isActive ? 'Active' : 'Inactive'
  }
}
